
import { useCreateQuiz } from '@/store/createQuiz'
import { computed, defineComponent } from 'vue'
import BaseInput from '@/components/BaseInput.vue'
import BaseButton from '@/components/BaseButton.vue'
import BaseTextarea from '@/components/BaseTextarea.vue'
import BaseSelect from '@/components/BaseSelect.vue'
import BaseCheckbox from '@/components/BaseCheckbox.vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'create-quiz-view',
  components: { BaseInput, BaseButton, BaseTextarea, BaseSelect, BaseCheckbox },
  setup() {
    const store = useCreateQuiz()
    const router = useRouter()

    const questionTypes = [
      { value: 'SINGLE', text: 'С одним ответом' },
      { value: 'MULTI', text: 'С несколькими ответами' },
      { value: 'WRITTEN', text: 'Без вариантов ответа' },
    ]

    async function saveQuiz() {
      await store.saveQuiz()
      router.push('/dashboard')
    }

    return {
      store,
      questionTypes,
      saveQuiz,
      canCreate: computed(
        () =>
          store.questions.length !== 0 &&
          store.name &&
          store.questions.filter(
            (q) =>
              !q.text ||
              (q.type !== 'WRITTEN' &&
                (q.variants.filter((v) => !v.text).length > 0 ||
                  q.variants.filter((v) => v.isTrue).length === 0))
          ).length === 0
      ),
    }
  },
})
